import './ModuleCTA.scss';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Redo } from 'images/icons/RedoThin.svg';
import { ReactComponent as Play } from 'images/icons/PlayThin.svg';
import { useNavigate } from 'react-router-dom';

type ModuleCTAProps = {
  isModuleCompleted: boolean;
  isModuleStarted: boolean;
  slug: string;
};

export const ModuleCTA = ({ isModuleStarted, isModuleCompleted, slug }: ModuleCTAProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const buttonIcon = () => {
    if (isModuleCompleted) {
      return <Redo className='icon' />;
    } else if (!isModuleStarted) {
      return <Play className='icon' />;
    } else {
      return <></>;
    }
  };

  const buttonText = () => {
    if (isModuleCompleted) {
      return t('RestartModule', { ns: 'learningHub' });
    } else if (!isModuleStarted) {
      return t('StartModule', { ns: 'learningHub' });
    } else {
      return t('ResumeModule', { ns: 'learningHub' });
    }
  };
  return (
    <Button
      style={{ backgroundColor: isModuleCompleted ? '#414141' : '#ec691a' }}
      className='button'
      variant='contained'
      startIcon={buttonIcon()}
      onClick={() => navigate('Module', { relative: 'path' })}
    >
      {buttonText()}
    </Button>
  );
};
